export default {
  "Coleta domiciliar": {
    valor: 'Coleta domiciliar',
  },
  "Coleta empresarial ": {
    valor: 'Coleta empresarial ',
  },
};
